import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Pipe({
    name: 'exportName',
})
export class ExportNamePipe implements PipeTransform {
    constructor (private readonly translateService: TranslateService) {}

    transform (value: string): string {
        switch (value) {
            case 'pages_documents':
                return this.translateService.getString('Documents extended');
            case 'inventory_document_pages':
                return this.translateService.getString('Documents basic');
            case 'dead_page_links':
                return this.translateService.getString('Broken Page Link');
            case 'scan_history_overview':
                return this.translateService.getString('Compound Report');
            case 'site_search_keywords':
                return this.translateService.getString('Site Search - Search Terms');
            case 'site_search_no_result_keywords':
                return this.translateService.getString('Site Search No Results Search Terms');
            default:
                return value.replace(/_/g, ' ');
        }
    }
}
